export default __webpack_public_path__ + "static/media/welcome.dfc33035.png";